module.exports = __webpack_public_path__ + "static/media/mailsmall-icon.ba904dff.svg";